var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.eliminar",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{on:{"click":function($event){return _vm.$emit('eliminar',item)}}},[_vm._v("mdi-delete")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }